import { execOnLoad } from '@general/helpers';
import './page.styleguide.scss';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initStyleguide = (context) => {
  const templateContainer = context.classList.contains('.styleguide__container')
    ? context
    : context.closest('.styleguide__container');
  if (!templateContainer) return;

  templateContainer
    .querySelectorAll('.styleguide__colors-box')
    .forEach((color) => {
      const example = color.querySelector('.styleguide__colors-box-example');
      const hex = color.querySelector('.styleguide__colors-box-hex');
      if (!example || !hex) return;

      hex.innerText = getComputedStyle(example).backgroundColor;
    });

  templateContainer
    .querySelectorAll(
      '.styleguide__breakpoints [name="active_breakpoint"][type="radio"]',
    )
    .forEach((radio) =>
      radio.addEventListener(
        'click',
        () => (templateContainer.style.maxWidth = radio.value),
      ),
    );

  const buttonsWrapper = templateContainer.querySelector(
    '.styleguide__buttons',
  );
  if (buttonsWrapper)
    buttonsWrapper
      .querySelectorAll('input[type="checkbox"]')
      .forEach((checkbox) =>
        checkbox.addEventListener('click', () =>
          buttonsWrapper.classList.toggle(
            `styleguide__buttons--${checkbox.name}`,
          ),
        ),
      );

  const spacingsWrapper = templateContainer.querySelector(
    '.styleguide__spacings',
  );
  if (spacingsWrapper) {
    const columnsSelect = spacingsWrapper.querySelector(
      'select[name="columns"]',
    );
    const columnsGrid = spacingsWrapper.querySelector(
      '.styleguide__spacings-columns-grid[data-cols]',
    );
    if (columnsSelect && columnsGrid)
      columnsSelect.addEventListener(
        'change',
        () => (columnsGrid.dataset.cols = columnsSelect.value),
      );
  }
};

execOnLoad(window.dAgency.initStyleguide, '.styleguide__container');
